<!--
component: Map
author: Ken Nakamura
description: 地図コンポーネント (OpenLayers使用)
-->
<template>
  <section class="map">
    <div id="map" width="100%" height="100%"></div>
  </section>
</template>

<script>
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import {Attribution, defaults as defaultControls} from 'ol/control';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import Vector from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import VectorTile from 'ol/source/VectorTile';
import VectorTileLayer from 'ol/layer/VectorTile';
import MVT from 'ol/format/MVT';
//import VectorSource from 'ol/source/Vector';
//import GeoJSON from 'ol/format/GeoJSON';
//import {toContext} from 'ol/render';
import { /*fromLonLat,*/ transform } from 'ol/proj';
import { Style, Circle, Fill, Stroke } from 'ol/style';
import Feature from 'ol/Feature';
import { LineString, Point, Polygon } from 'ol/geom';
import { ZoomSlider, ScaleLine } from 'ol/control';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import store from '../store'
import { dbglog, bgmapUrl /*, plotUrl */} from '../common/utils'

// OpenLayersのイベントハンドラから呼び出すためVueの外側に置く必要がある
var vectorLayer;
var vectorLayerAlt;
var sheetLayer;
var features;
///* ポリゴン選択表示対応（まだうまく行っていない）
var polygonAsSelection = true;
var lineAsSelection = true;
//var selectionLayer;
//var selectionLayerAlt;
let selection = {};
let selectionAlt = {};
//*/
var drawingSource;
var plotKey;
var plotLabel;
var plotType;
var plotKeyAlt;
//var plotLabelAlt;
//var plotTypeAlt;

export default {
  data () {
    return {
      mounted: false,
      map: null,
      tileLayer: null,
      tileLayerAlt: null,
      drawingLayer: null,
      normalStyle: null,
      normalStyleAlt: null,
      selectedStyle: null,
      douroShubetsuLayer: null,
      seibiSokushinLayer: null,
    }
  },
  props: {
    targetPlot: {
      type: Object,
      default: null,
    },
    centerx: {
      type: Number,
      default: -18033.043,  // 横浜市役所付近
      validator: (value) => {
        // 平面直角座標系の座標範囲
        return value > -130000 && value < 130000;
      },
    },
    centery: {
      type: Number,
      default: -61003.664,  // 横浜市役所付近
      validator: (value) => {
        // 平面直角座標系の座標範囲
        return value > -130000 && value < 130000;
      },
    },
    zoom: {
      type: Number,
      default: 18,
    },
    plotDef: {
      type: Object,
      default: null,
    },
    plotDefAlt: {
      type: Object,
      default: null,
    },
    tileUrl: {
      type: String,
      default: '',
    },
    tileUrlAlt: {
      type: String,
      default: '',
    },
    sheetUrl: {
      type: String,
      default: '',
    },
    bgmapList: {
      type: Array,
      default: null,
    },
  },
  computed: {
    douroShubetsuVisible() {
      return this.$store.state.douroShubetsuVisible;
    },
    seibiSokushinVisible() {
      return this.$store.state.seibiSokushinVisible;
    },
    mapAttribution() {
      return this.$store.state.mapAttribution;
    }
  },
  created () {
    // regist projection for japan-zone
    proj4.defs("EPSG:2451","+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    proj4.defs("EPSG:6677","+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs");
    register(proj4);
  },
  watch: {
    douroShubetsuVisible: {
      immediate: true,
      handler(value) {
        if (this.douroShubetsuLayer) {
          this.douroShubetsuLayer.setVisible(value);
        }
      }
    },
    seibiSokushinVisible: {
      immediate: true,
      handler(value) {
        if (this.seibiSokushinLayer) {
          this.seibiSokushinLayer.setVisible(value);
        }
      }
    },
    /*
    targetPlot: {
      immediate: true,
      handler(value) {
        if (value) {
          drawingSource.clear();
          const coord4326 = transform([value.x, value.y], "EPSG:2451", "EPSG:4326");
          const coord3857 = transform(coord4326, "EPSG:4326", "EPSG:3857");
          const coord = coord3857;
          const point = new Point(coord);
          const feature = new Feature({
            geometry: point,
            受付番号: this.targetPlot.uke_no, 
          });
          const layerFeature = {layer:'vectorLayer', feature:feature};
          features.push(layerFeature);
          this.setFeatures(features);
          selectFeature(layerFeature);
        }
      }
    },
    */
  },
  mounted () {
    if (!this.mounted) {
      //const radius = this.$store.state.plotRadius;
      this.createMap(this.centerx, this.centery, this.zoom);
      this.normalStyle = this.createNormalStyle(4);
      this.normalStyleAlt = this.createNormalStyleAlt(4);
      this.selectedStyle = this.createSelectedStyle(4);
      if (this.bgmapList && this.bgmapList.length) {
        for (let i = 0; i < this.bgmapList.length; i++) {
          if (this.bgmapList[i].indexOf('seibi') > 0) {
            const lyr = this.createVectorTileLayer(this.bgmapList[i], this.createAdditionalBgmapPolygonStyle());
            lyr.setVisible(this.seibiSokushinVisible);
            this.map.addLayer(lyr);
            this.seibiSokushinLayer = lyr;
          }
          else {
            //const lyr = this.createVectorTileLayer(this.bgmapList[i], this.createAdditionalBgmapStyle(5));
            //const lyr = this.createVectorTileLayer(this.bgmapList[i], null);
            const lyr = this.createThematicLayer(this.bgmapList[i]);
            lyr.setVisible(this.douroShubetsuVisible);
            this.map.addLayer(lyr);
            this.douroShubetsuLayer = lyr;
          }
        }
      }
      if (this.plotDef.type == 'polygon') {
        if (polygonAsSelection) {
          const normalStyle = this.createPolygonStyle();
          const selectedStyle = this.createSelectedStyle(4);
          this.tileLayer = this.createSelectableTileLayer(this.tileUrl, this.plotDef.key, normalStyle, selectedStyle);
        }
        else {
          this.tileLayer = this.createVectorTileLayer(this.tileUrl, this.createPolygonStyle());
        }
      }
      else if (this.plotDef.type == 'line') {
        if (lineAsSelection) {
          const selectedStyle = this.createSelectedStyle(4);
          this.tileLayer = this.createSelectableTileLayer(this.tileUrl, this.plotDef.key, this.normalStyle, selectedStyle);
        }
        else {
          this.tileLayer = this.createVectorTileLayer(this.tileUrl, this.normalStyle);
        }
      }
      else {
        this.tileLayer = this.createVectorTileLayer(this.tileUrl, this.normalStyle);
      }
      this.map.addLayer(this.tileLayer);
      vectorLayer = this.tileLayer;
      if (this.tileUrlAlt != '') {
        if (this.plotDefAlt.type == 'polygon') {
          if (polygonAsSelection) {
            const normalStyle = this.createPolygonStyleAlt();
            const selectedStyle = this.createSelectedStyle(4);
            this.tileLayerAlt = this.createSelectableTileLayerAlt(this.tileUrlAlt, this.plotDefAlt.key, normalStyle, selectedStyle);
          }
          else {
            this.tileLayerAlt = this.createVectorTileLayer(this.tileUrlAlt, this.createPolygonStyleAlt());
          }
        }
        else {
          this.tileLayerAlt = this.createVectorTileLayer(this.tileUrlAlt, this.normalStyleAlt);
        }
        this.map.addLayer(this.tileLayerAlt);
        vectorLayerAlt = this.tileLayerAlt;
      }
      if (this.sheetUrl != '') {
        sheetLayer = this.createVectorTileLayer(this.sheetUrl, this.createHiddenStyle());
        this.map.addLayer(sheetLayer);
      }
      else {
        sheetLayer = null;
      }
      this.drawingLayer = this.createDrawingLayer(this.selectedStyle);
      this.map.addLayer(this.drawingLayer);
      // ポリゴン選択表示対応
      if (polygonAsSelection) {
        //selectionLayer = this.tileLayer;
        //selectionLayerAlt = this.tileLayerAlt;
        /*
        selectionLayer = new VectorTileLayer({
          map: this.map,
          renderMode: 'vector',
          souce: vectorLayer.getSource(),
          style: function (feature) {
            if (feature.getId() in selection) {
              return this.selectedStyle;
            }
            const id = feature.get('開発許可NO');
            for (const item in selection) {
              if (item.key == id)
                return this.selectedStyle;
            }
          },
        })
        */
      }
      this.setMapEventHandler(this.map);
      this.mounted = true;  // 意味が無かったかもしれない
    }
    dbglog('Map:' + this.plotDef);
    plotKey = this.plotDef.key;
    plotLabel = this.plotDef.label;
    plotType = this.plotDef.type;
    if (this.plotDefAlt !== null) {
      plotKeyAlt = this.plotDefAlt.key;
      //plotLabelAlt = this.plotDefAlt.label;
      //plotTypeAlt = this.plotDefAlt.type;
    }

    dbglog(`features length = ${store.state.features.length}`);
    try {
      for (let i = 0; i < store.state.features.length; i++) {
        const feature = store.state.features[i];
        selectFeature(feature);
      }
    }
    catch (err) {
      dbglog(`Map.mounted: error ${err}`, -1);
    }

    // プロット図ジャンプで遷移してきた場合
    if (this.targetPlot) {
      features = [];
      drawingSource.clear();
      const coord4326 = transform([this.targetPlot.x, this.targetPlot.y], "EPSG:2451", "EPSG:4326");
      const coord3857 = transform(coord4326, "EPSG:4326", "EPSG:3857");
      const coord = coord3857;
      const point = new Point(coord);
      const feature = new Feature({
        geometry: point,
        受付番号: this.targetPlot.uke_no, 
      });
      //test: 2022.08.07
      //features.push(feature);
      //selectFeature(feature);
      const layerFeature = {layer: 'vectorLayer', feature: feature};
      features.push(layerFeature);
      //
      this.setFeatures(features);
      selectFeature(layerFeature);
    }
  },
  methods: {
    /**
     * 選択されたフィーチャを登録する
     */
    setFeatures: (val) => {
      store.commit('setFeatures', val);
    },
    /**
     * OpenLayersマップを作成する
     */
    createMap(cx, cy, zoomLevel) {
      const coord4326 = transform([cx, cy], "EPSG:2451", "EPSG:4326");
      const coord3857 = transform(coord4326, "EPSG:4326", "EPSG:3857");
      dbglog(`(${cx},${cy})->${coord4326}->${coord3857}`);
      const attribution = new Attribution({
        collapsible: false,
      });

      this.map = new Map ({
        target: 'map',
        renderer: ['canvas', 'dom'],
        layers: [
          new TileLayer({
            source: new XYZ({
              //attributions: "横浜市都市計画図",
              //attributions: "この地図の著作権は横浜市が保有します。",
              attributions: this.mapAttribution,
              url: bgmapUrl(),
              projection: "EPSG:3857"
            })
          })
        ],
        view: new View({
          projection: "EPSG:3857",
          center: coord3857,
          minZoom: 14,
          maxZoom: 20,
          zoom: zoomLevel,
        }),
        controls: defaultControls({attribution: false}).extend([attribution]),
        /*
        controls: Control.defaults({
          attributionOptions: ({
            collapsible: false
          }),
        }),
        */
      });
      this.map.addControl(new ZoomSlider({
          minResolution: 0.1,
          maxResolution: 9.0,
      }));
      this.map.addControl(new ScaleLine({
          units: 'metric',
      }));
    },
    /**
     * 確認プロット用のベクトルタイル・レイヤを作成する
     * @param {String} tileUrl タイルデータのURL
     * @param {Style} normalStyle レイヤに適用されるスタイル
     * @return { VectorTileLayer }  作成されたレイヤ・オブジェクトを返す
     */
    createVectorTileLayer(tileUrl, normalStyle) {
      dbglog(`opening vector tile Layer ${tileUrl}`);
      const parcelsSource = new VectorTile({
          format: new MVT({
            //idProperty: this.plotDef.key,
          }),
          url: tileUrl,
          projection: 'EPSG:3857',
      });
      const parcelsLayer = new VectorTileLayer({
          source: parcelsSource,
          style: normalStyle,
          minResolution: 0.1,
          maxResolution: 5,
      });
      return parcelsLayer;
    },
    createSelectableTileLayer(tileUrl, keyName, normalStyle, selectedStyle) {
      const parcelsSource = new VectorTile({
          format: new MVT({
            //idProperty: this.plotDef.key,
          }),
          url: tileUrl,
          projection: 'EPSG:3857',
      });
      const parcelsLayer = new VectorTileLayer({
          source: parcelsSource,
          style: function (feature) {
            if (feature.get(keyName) in selection) {
              return selectedStyle;
            }
            else {
              return normalStyle;                  
            }
          },
          minResolution: 0.1,
          maxResolution: 5,
      });
      return parcelsLayer;
    },
    createSelectableTileLayerAlt(tileUrl, keyName, normalStyle, selectedStyle) {
      const parcelsSource = new VectorTile({
        format: new MVT(),
        url: tileUrl,
        projection: 'EPSG:3857',
      });

      const parcelsLayer = new VectorTileLayer({
        source: parcelsSource,
        
        /*
          style: function (feature) {
          if (feature.get(keyName) in selectionAlt) {
            return selectedStyle;
            }
            else {
              return normalStyle;                  
            }
          },
          minResolution: 0.1,
          maxResolution: 5,
        source: parcelsSource,
        */

        style: function(feature) {
          // まず選択状態をチェック
          if (feature.get(keyName) in selectionAlt) {
            return selectedStyle;
          }

          // 宅造許可NOの値を取得
          const takuzoNo = feature.get('宅造許可NO');
          
          // 特定の文字列に基づいて色を変更
          if ((takuzoNo && takuzoNo.includes('宅規')) || (takuzoNo && takuzoNo.includes('農規')) || (takuzoNo && takuzoNo.includes('森規'))) {
            return new Style({
              stroke: new Stroke({
                color: 'rgb(255,165,0)',  // オレンジ
                width: 1.0,
              }),
              fill: new Fill({
                color: 'rgba(255,165,0,0.1)',
              }),
            });
          } else if (takuzoNo && takuzoNo.includes('土規')) {
            return new Style({
              stroke: new Stroke({
                color: 'rgb(200,0,200)',  // ピンク・紫
                width: 1.0,
              }),
              fill: new Fill({
                color: 'rgba(200,0,200,0.1)',
              }),
            });
          }
          
          // デフォルトのスタイル
          return normalStyle;
        },
        minResolution: 0.1,
        maxResolution: 5,
      });
      
      return parcelsLayer;
    },
    // test
    getRoadColor(code) {
      switch (code) {
        case 110: //法第42条第1項第1号道路（道路幅員4m以上）
          return "#00ee33bb";
        case 120: //法第42号第1項第2号道路（道路幅員4m以上）
          return "#77bb33bb";
        case 130: //法第42号第1項第3号道路（道路幅員4m以上）
          return "#88ccffbb";
        case 140:
          return "#eeee00bb";
        case 150: //法第42号第1項第5号道路（道路幅員4m以上）
          return "#eeaa00bb";
        case 160: //法第42号第1項道路
          return "#007700bb";
        case 200: //法第42条第2項道路
          return "#0000ffbb";
        case 400: //法第43条第2項第1号の認定又は同項第2号の許可を要する道路状空地
          return "#ff0000bb";
        case 500: //法第42号（道路）に該当しない（否通路）
          return "#dd88ffbb";
        default:
          return "#000000bb";
      }
    },
    createThematicLayer(url) {
      const parcelsSource = new VectorTile({
          format: new MVT(),
          url: url,
          projection: 'EPSG:3857',
      });
      const parcelsLayer = new VectorTileLayer({
          source: parcelsSource,
          style: (feature) => {
            const code = feature.get('道路種別');
            const color = this.getRoadColor(code);
            return new Style({
              stroke: new Stroke({
                color: color,
                width: 4,
              }),
            });            
          },
          minResolution: 0.1,
          maxResolution: 5,
      });
      return parcelsLayer;
    },
    /**
     * 選択されたプロットを表示させるための描画レイヤを作成する
     * @param {Style} selectedStyle レイヤに適用されるスタイル
     * @return { VectorLayer }  作成されたレイヤ・オブジェクトを返す
     */
    createDrawingLayer(selectedStyle) {
      drawingSource = new Vector({
          features: [],
      });
      const drawingLayer = new VectorLayer({
          source: drawingSource,
          style: selectedStyle,
      });
      return drawingLayer;
    },
    /**
     * プロット標準表示スタイルを作成する
     * @param { Number } r ポイント描画スタイルの半径（ピクセル）
     * @return { Style }  作成されたスタイル・オブジェクトを返す
     */
    createNormalStyle(r) {
      const style = new Style({
        image: new Circle({
          radius: r,
          fill: new Fill({
            color: 'rgba(0,0,255,0.5)',
          }),
        }),
        stroke: new Stroke({
          color: 'rgb(0,0,255)',
          width: 3.0,
        }),
        fill: new Fill({
          color: 'rgba(0,0,255,0.1)',
        }),
      });
      return style;
    },
    createNormalStyleAlt(r) {
      const style = new Style({
        image: new Circle({
          radius: r,
          fill: new Fill({
            color: 'rgba(0,255,0,0.5)',
          }),
        }),
        stroke: new Stroke({
          color: 'rgb(0,255,0)',
          width: 3.0,
        }),
        fill: new Fill({
          color: 'rgba(0,255,0,0.1)',
        }),
      });
      return style;
    },
    createPointStyle(r) {
      const style = new Style({
        image: new Circle({
          radius: r,
          fill: new Fill({
            color: 'rgba(0,0,255,0.5)',
          }),
        }),
      });
      return style;
    },
    createLineStyle(w) {
      const style = new Style({
        stroke: new Stroke({
          color: 'rgb(0,0,255)',
          width: w,
        }),
      });
      return style;
    },
    createPolygonStyle() {
      const style = new Style({
        stroke: new Stroke({
          color: 'rgb(0,0,255)',
          width: 1.0,
        }),
        fill: new Fill({
          color: 'rgba(0,0,255,0.1)',
        }),
      });
      return style;
    },
    createPolygonStyleAlt() {
      const style = new Style({
        stroke: new Stroke({
          color: 'rgb(0,255,0)',
          width: 1.0,
        }),
        fill: new Fill({
          color: 'rgba(0,255,0,0.1)',
        }),
      });
      return style;
    },
    createHiddenStyle() {
      const style = new Style({
        stroke: new Stroke({
          color: 'rgb(255,255,0,0.0)',
          width: 0.0,
          //for debug
          //color: 'rgb(255,255,0,0.5)',
          //width: 0.5,
        }),
        fill: new Fill({
          color: 'rgba(255,255,0,0.0)',
        }),
      });
      return style;
    },
    createAdditionalBgmapStyle(w) {
      const style = new Style({
        stroke: new Stroke({
          color: 'rgb(127,127,0,0.5)',
          width: w,
        }),
        fill: new Fill({
          color: 'rgba(255,255,0,0.1)',
        }),
      });
      return style;
    },
    createAdditionalBgmapPolygonStyle() {
      const style = new Style({
        stroke: new Stroke({
          color: 'rgb(180,130,180,0.5)',
          width: 0,
        }),
        fill: new Fill({
          color: 'rgba(180,130,180,0.5)',
        }),
      });
      return style;
    },
    /**
     * プロット強調表示スタイルを作成する
     * @param { Number } r ポイント描画スタイルの半径（ピクセル）
     * @return { Style }  作成されたスタイル・オブジェクトを返す
     */
    createSelectedStyle(r) {
      const style = new Style({
        image: new Circle({
          radius: r,
          fill: new Fill({
              color: 'rgb(255,0,0)',
          }),
          stroke: new Stroke({
              color: 'rgb(255,0,0)',
              width: 1.0,
          }),
        }),
        stroke: new Stroke({
          color: 'rgb(255,0,0)',
          width: 3.0,
        }),
        fill: new Fill({
          color: 'rgba(255,0,0,0.1)',
        }),
      });
      return style;
    },
    createSelectedStyleAlt(r) {
      const style = new Style({
        image: new Circle({
          radius: r,
          fill: new Fill({
              color: 'rgb(255,0,0)',
          }),
          stroke: new Stroke({
              color: 'rgb(255,0,0)',
              width: 1.0,
          }),
        }),
        stroke: new Stroke({
          color: 'rgb(255,0,0)',
          width: 3.0,
        }),
        fill: new Fill({
          color: 'rgba(255,0,0,0.1)',
        }),
      });
      return style;
    },
    /**
     * マップがクリックされた時に実行されるイベントハンドラ
     */
    onMapClick(e) {
      //console.log(e.pixel);
      const res = this.map.getView().getResolution();
      dbglog(`map resolution = ${res}`);
      features = [];
      drawingSource.clear();
      if (polygonAsSelection) {
        selection = {};
        selectionAlt = {};
        selectFeature(null);
      }

      this.map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
          if (layer === vectorLayer) {
            const keyValue = feature.get(plotKey);
            //if (keyValue !== undefined && keyValue !== null && keyValue.length > 0) {
            if (keyValue) {
              const found = features.some(ft => ft.feature?.get(plotKey) == keyValue);
              // すでに登録されているIDなら追加しない
              if (!found) {
                //test: 2022.08.06
                //features.push(feature);
                //selectFeature(feature);
                const layerFeature = {layer: 'vectorLayer', feature: feature};
                features.push(layerFeature);
                selectFeature(layerFeature);
                //
              }
            }
          }
          else if (layer === vectorLayerAlt) {
            const keyValue = feature.get(plotKeyAlt);
            //if (keyValue !== undefined && keyValue !== null && keyValue.length > 0) {
            if (keyValue) {
              const found = features.some(ft => ft.feature?.get(plotKeyAlt) == keyValue);
              // すでに登録されているIDなら追加しない
              if (!found) {
                //test: 2022.08.06
                //features.push(feature);
                //selectFeature(feature);
                const layerFeature = {layer: 'vectorLayerAlt', feature: feature};
                features.push(layerFeature);
                selectFeature(layerFeature);
                //
              }
            }
          }
          else {
            //selectFeature(null);
          }
        },
        {
          hitTolerance: 7,
          layerFilter: function (layer) {
              return (layer === vectorLayer || layer === vectorLayerAlt);
          }
        });

      this.setFeatures(features);
    },
    /**
     * OpenLayersマップにイベントハンドラを追加する
     * @param { Map } map イベントハンドラを設定するOpenLayers Mapオブジェクト
     */
    setMapEventHandler(map) {
      map.on('pointermove', function (e) {
        if (e.dragging) {
          const coord3857 = map.getView().getCenter();
          const coord4326 = transform(coord3857, "EPSG:3857", "EPSG:4326");
          const coord2451 = transform(coord4326, "EPSG:4326", "EPSG:2451");
          const c = { x: coord2451[0], y: coord2451[1] };
          dbglog(`map center (${store.state.centerx},${store.state.centery})->${c.x},${c.y})`);
          store.commit('setCenter', c);
          // 画面中心のプロット図郭を取得する
          const sheets = detectSheets(map);
          store.commit('setSheets', sheets);
        }
      });
      map.on('postcompose', () => {
          const sheets = detectSheets(map);
          store.commit('setSheets', sheets);
      }),
      map.on('click', this.onMapClick);
    },
  },
}

/**
 * featureを選択状態にする
 * @param {Feature} feature 選択状態にする対象フィーチャ
 */
function selectFeature(layerFeature) {
  if (!layerFeature) {
    if (polygonAsSelection || lineAsSelection) {
      selection = {};
      selectionAlt = {};
      vectorLayer.changed();
      vectorLayerAlt?.changed();
    }
    return;
  }
  const layer = layerFeature.layer;
  const feature = layerFeature.feature;
  const geom = feature.getGeometry();
  const ext = geom.getExtent();
  if (plotType == 'point') {
    const point = new Feature({
      geometry: new Point([ext[0], ext[1]]),
      key: feature.get(plotKey),
      label: feature.get(plotLabel),
    });
    drawingSource.addFeature(point);
  }
  else if (plotType == 'line') {
    if (lineAsSelection) {
      const fid = feature.get(plotKey);
      if (fid) {
        selection[fid] = feature;
      }
      vectorLayer.changed();
    }
    else {
      //let lineGeom: ol.geom.LineString = <ol.geom.LineString>geom;
      let coords = [];
      const fcoords = geom.getFlatCoordinates();
      for (let i = 0; i < fcoords.length; i+=2) {
        const p = [fcoords[i], fcoords[i+1]];
        coords.push(p);
      }
      let line = new Feature({
        geometry: new LineString(coords),
        key: feature.get(plotKey),
        label: feature.get(plotLabel),
      });
      drawingSource.addFeature(line);
    }
  }
  else if (plotType == 'polygon') {
    if (polygonAsSelection) {
      // ポリゴン選択表示対応
      //selection = {};
      if (!feature) {
        vectorLayer.changed();
        vectorLayerAlt.changed();
        return;
      }
      const fid = feature.get(plotKey);
      const fidAlt = feature.get(plotKeyAlt);
      if ((layer == 'vectorLayer') && fid) {
        selection[fid] = feature;
        vectorLayer.changed();
      }
      if ((layer == 'vectorLayerAlt') && fidAlt) {
        selectionAlt[fidAlt] = feature;
        vectorLayerAlt.changed();
      }
    }
    else {
      let coords = [];
      const fcoords = geom.getFlatCoordinates();
      for (let i = 0; i < fcoords.length; i+=2) {
        const p = [fcoords[i], fcoords[i+1]];
        coords.push(p);
      }
      dbglog(coords);
      const pgngeom = new Polygon([coords]);
      dbglog(pgngeom);
      const polygon = new Feature({
        geometry: pgngeom,
        key: feature.get(plotKey),
        label: feature.get(plotLabel),
      });
      drawingSource.addFeature(polygon);
    }
  }
}

function detectSheets(map) {
  const cx = map.viewport_.clientWidth / 2;
  const cy = map.viewport_.clientHeight / 2;
  const pixel = [cx, cy];
  let sheets = [];
  map.forEachFeatureAtPixel(pixel, function (feature, layer) {
    if (layer === sheetLayer) {
      const indexId = feature.get('INDEX_ID');
      const pageNo = feature.get('PAGENO');
      const branch = feature.get('BRANCH');
      sheets.push({ indexId: indexId, pageNo: pageNo, branch: branch });
    }
  },
  {
    hitTolerance: 0,
    layerFilter: function (layer) {
        return (layer === sheetLayer);
    }
  });
  return sheets;
}

</script>

<style lang="scss" scoped>
#map {
  z-index: 0;
  /* 高さの初期値は要検討 */
  //height: calc(100vh - 60px - 30px);
  height: calc(100vh - 60px - 45px);
}
</style>